module.exports = __webpack_public_path__ + "42ed5b3f0466497f19c800216a30f497.pdf";